<app-banner [heading]="'OUR STUDENT COUNCIL'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
<section id="about" class="mb-4">

  <div class="container">
    <div class="row">

      <div class="col-lg-6 col-md-6">
        <div class="about-img">
          <img src="/assets/img/student/1.jpeg" alt="best school in kurukshetra">
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="about-content">
          <h6 class=""> Our Houses</h6>
          
          <p>The House System occupies a prominent position in the field of Co-curricular Activities, which are organized in a healthy competitive spirit. Each student is allotted a particular house at the time of admission and he/she continues his/her loyalty to the house during his/her stay in the school.<br><br>
            It helps the students to learn great ideals of self-discipline, democratic leadership,loyalty and belongingess to the institution.<br><br>
            The school is presently divided into 4 houses viz Shakespeare, Wordsworth, Coleridge and Shelley.
    </p>
          
        </div>
      </div>

    </div>
  </div>

</section>
<app-banner [heading]="'SPORTS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
<section class="events3" >
  <div class="container" >
  <div class="row d-flex justify-content-between"><!-- ======= Grade II ======= -->
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card"></div>
  </div>
  <!-- ======= Grade II ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/2.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Master Jatin</h5>
  
  <p class="designation">Captain</p>
  
  <p class="experience">Sports</p>
  </div>
  </div>
  </div>
  
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/3.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Master Sameer</h5>
  
  <p class="designation">Vice Captain</p>
  
  <p class="experience">Sports</p>
  </div>
  </div>
  </div>
  <!-- ======= Grade II ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card"></div>
  </div>
  <!-- ======= Grade II ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="about-img"><img alt="" class="img-fluid" src="/assets/img/student/4.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Ms. Shikha</h5>
  
  <p class="designation">Overall House Incharge</p>
  
  <p class="experience"></p>
  </div>
  </div>
  </div>
  <!-- ======= Blank ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card"></div>
  </div>
  </div>
  </div>
  </section>
  <app-banner [heading]="'SHAKESPEAR HOUSE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
  <section class="events3">
    <div class="container" >
    <div class="row d-flex justify-content-between"><!-- ======= Grade II ======= -->
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card"></div>
    </div>
    <!-- ======= Grade II ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/5.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Ms. Pooja</h5>
    
    <p class="designation">House Mistress</p>
    
    <p class="experience">Shakespear House</p>
    </div>
    </div>
    </div>
    <!-- ======= Blank ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card"></div>
    </div>
    <!-- ======= Blank ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/6.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Master Dhruv</h5>
    
    <p class="designation">Captain</p>
    
    <p class="experience">Shakespear House</p>
    </div>
    </div>
    </div>
    <!-- ======= Grade II ======= --><!-- ======= Grade III ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/7.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Master Jayant</h5>
    
    <p class="designation">Vice Captain</p>
    
    <p class="experience">Shakespear House</p>
    </div>
    </div>
    </div>
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/8.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Ms. Raghvi</h5>
    
    <p class="designation">Prefect</p>
    
    <p class="experience">Shakespear House</p>
    </div>
    </div>
    </div>
    </div>
    </div>
    </section>
    <app-banner [heading]="'WORDSWORTH HOUSE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
    <section class="events3" >
<div class="container">
<div class="row d-flex justify-content-between"><!-- ======= Grade II ======= -->
<div class="col-md-4 d-flex align-items-stretch">
<div class="card"></div>
</div>
<!-- ======= Grade II ======= -->

<div class="col-md-4 d-flex align-items-stretch">
<div class="card">
<div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/9.jpeg"></div>

<div class="card-body">
<h5 class="card-title">Ms. Sakshi</h5>

<p class="designation">House Mistress</p>

<p class="experience">Wordsworth House</p>
</div>
</div>
</div>
<!-- ======= Blank ======= -->

<div class="col-md-4 d-flex align-items-stretch">
<div class="card"></div>
</div>
<!-- ======= Blank ======= -->

<div class="col-md-4 d-flex align-items-stretch">
<div class="card">
<div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/10.jpeg"></div>

<div class="card-body">
<h5 class="card-title">Ms. Priyanshi</h5>

<p class="designation">Captain</p>

<p class="experience">Wordsworth House</p>
</div>
</div>
</div>
<!-- ======= Grade II ======= --><!-- ======= Grade III ======= -->

<div class="col-md-4 d-flex align-items-stretch">
<div class="card">
<div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/11.jpeg"></div>

<div class="card-body">
<h5 class="card-title">Master Kunal</h5>

<p class="designation">Vice Captain</p>

<p class="experience">Wordsworth House</p>
</div>
</div>
</div>

<div class="col-md-4 d-flex align-items-stretch">
<div class="card">
<div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/12.jpeg"></div>

<div class="card-body">
<h5 class="card-title">Ms. Vanika Saini</h5>

<p class="designation">Prefect</p>

<p class="experience">Wordsworth House</p>
</div>
</div>
</div>

<div class="col-md-4 d-flex align-items-stretch">
<div class="card">
<div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/13.jpeg"></div>

<div class="card-body">
<h5 class="card-title">Ms. Turanya</h5>

<p class="designation">Prefect</p>

<p class="experience">Wordsworth House</p>
</div>
</div>
</div>
</div>
</div>
</section>

<app-banner [heading]="'COLERIDGE HOUSE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
<section class="events3" >
  <div class="container" >
  <div class="row d-flex justify-content-between"><!-- ======= Grade II ======= -->
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card"></div>
  </div>
  <!-- ======= Grade II ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/14.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Ms. Vimal Kaler</h5>
  
  <p class="designation">House Mistress</p>
  
  <p class="experience">Coleridge House</p>
  </div>
  </div>
  </div>
  <!-- ======= Blank ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card"></div>
  </div>
  <!-- ======= Blank ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/15.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Master Jaskirat</h5>
  
  <p class="designation">Captain</p>
  
  <p class="experience">Coleridge House</p>
  </div>
  </div>
  </div>
  <!-- ======= Grade II ======= --><!-- ======= Grade III ======= -->
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/16.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Master Riyarth</h5>
  
  <p class="designation">Vice Captain</p>
  
  <p class="experience">Coleridge House</p>
  </div>
  </div>
  </div>
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/17.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Ms. Seerat</h5>
  
  <p class="designation">Prefect</p>
  
  <p class="experience">Coleridge House</p>
  </div>
  </div>
  </div>
  
  <div class="col-md-4 d-flex align-items-stretch">
  <div class="card">
  <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/18.jpeg"></div>
  
  <div class="card-body">
  <h5 class="card-title">Ms. Shikha</h5>
  
  <p class="designation">Prefect</p>
  
  <p class="experience">Coleridge House</p>
  </div>
  </div>
  </div>
  </div>
  </div>
  </section>

  <app-banner [heading]="'SHELLEY HOUSE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
  <section class="events3" >
    <div class="container" >
    <div class="row d-flex justify-content-between"><!-- ======= Grade II ======= -->
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card"></div>
    </div>
    <!-- ======= Grade II ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/19.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Ms. Samina</h5>
    
    <p class="designation">House Mistress</p>
    
    <p class="experience">Shelley House</p>
    </div>
    </div>
    </div>
    <!-- ======= Blank ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card"></div>
    </div>
    <!-- ======= Blank ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/20.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Master Kabir</h5>
    
    <p class="designation">Captain</p>
    
    <p class="experience">Shelley House</p>
    </div>
    </div>
    </div>
    <!-- ======= Grade II ======= --><!-- ======= Grade III ======= -->
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/21.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Master Shivam Talwar</h5>
    
    <p class="designation">Vice Captain</p>
    
    <p class="experience">Shelley House</p>
    </div>
    </div>
    </div>
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/22.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Ms. Nikunj</h5>
    
    <p class="designation">Prefect</p>
    
    <p class="experience">Shelley House</p>
    </div>
    </div>
    </div>
    
    <div class="col-md-4 d-flex align-items-stretch">
    <div class="card">
    <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/student/23.jpeg"></div>
    
    <div class="card-body">
    <h5 class="card-title">Ms. Nehal Ror</h5>
    
    <p class="designation">Prefect</p>
    
    <p class="experience">Shelley House</p>
    </div>
    </div>
    </div>
    </div>
    </div>
    </section>